import React, { useState } from 'react';
import { usePwa } from '@/hooks/usePwa';
import { Button } from '@/components/ui/button';
import { X, Download, Smartphone } from 'lucide-react';

/**
 * PwaInstallBanner — shows an install prompt at the bottom of the screen
 * for users who haven't installed the PWA yet.
 */
const PwaInstallBanner: React.FC = () => {
  const { isInstallable, isInstalled, promptInstall } = usePwa();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || isInstalled || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t shadow-lg animate-slide-up">
      <div className="max-w-lg mx-auto flex items-center gap-4">
        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 bg-rose-100 rounded-xl flex items-center justify-center">
          <Smartphone className="w-5 h-5 text-rose-600" />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900">Install Classifieds App</p>
          <p className="text-xs text-gray-500">Get a faster, app-like experience on your phone</p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={promptInstall}
            className="bg-rose-600 hover:bg-rose-700 text-white text-xs h-8"
          >
            <Download className="w-3.5 h-3.5 mr-1" />
            Install
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PwaInstallBanner;
